<template>
<div id="header" class="container-fluid">
      <div class="row p-0 ps-4 pe-4">

     
        <div class="col d-flex align-items-end justify-content-start">
          <img id="projelogo" alt="logo" class="clickable" src="@/assets/boa-logo.svg" onclick="location.href='/'"/>
        </div>
        <div class="menu col d-flex align-items-end justify-content-end">
         
          <a href="/proje-hakkinda">Proje Detayları</a><a href="mailto:bilgi@adalarmuzesi.org">İletişim</a>
        </div>
  </div>
</div>
<router-view/>
<div id="footer" class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <p class="text-center">Osmanlı Arşivleri'nde Prens Adaları, bir <span class="clickable" style="font-weight: 700;" onclick="window.open('https://adalarmuzesi.org', '_blank')">Adalar Müzesi</span> projesidir.
          <br><span style="font-size: 0.82rem;">Data güncellenme tarihi: 07/07/2024</span>
          <br><span class="clickable" style="font-size: 0.62rem;" onclick="window.open('https://extrarenk.com', '_blank')">Extra Renk tarafından Adalar Müzesi için hazırlanmıştır.</span></p>
      </div>
    </div>
  </div>
</template>

<style>
#app {
  font-family: "owners-text", sans-serif;
font-weight: 400;
font-style: normal;
/*font-family: "sharktooth", sans-serif;
font-weight: 400;
font-style: normal;*/
  font-size: 14px ;
  color:#2E4351; }
#header{
  height: 88px !important;
  background-color: #2E4351 !important;}
#header div{
  height: 68px !important;}
table,th,td{
  font-family: "calibri,arial, helvetica", sans-serif !important;
  color:#2E4351; 
}
  td:nth-last-child(1){
    text-align: justify;
  }
.menu a{ font-family: "calibri,arial, helvetica", sans-serif !important;
text-decoration: none;
color: #808285;
margin-left: 16px;
transition: all 0.28s}
.menu a:hover{ 
color: #ffffff;
margin-left: 16px;}
.clickable{ cursor: pointer !important;}
#projelogo{ width: 300px}

@media screen and (max-width: 592px) {
  #projelogo{ width: 140px;}
}

@media screen and (max-width: 380px) {
  #projelogo{ width: 100px;}
}

@media screen and (max-width: 350px) {
  #projelogo{ width: 80px;}
}



</style>
